import '../dashboard/dashboard.css';
import '../card/card.css';
import '../submission/submission.css';
import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CoverDisplay from '../components/ImagesPage';
import BannerImage from '../assets/Space.jpg';

const TARGET_OWNER = 'Matt L';
const TARGET_PSA_VAULT_TAG = 'PSA Vault - Matt L';

const toGradeNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

function MattLPage() {
  const [key, setKey] = useState('cardWall');
  const [cardList, setCardList] = useState([]);
  const [psaVaultCards, setPsaVaultCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let mounted = true;

    const loadCards = async () => {
      try {
        setLoading(true);
        setErrorMessage('');

        const [ownerResponse, tagResponse] = await Promise.all([
          Axios.get('https://api.alientrader.cards/data/dbsearch', {
            params: {
              card_owner: TARGET_OWNER,
            },
          }),
          Axios.get('https://api.alientrader.cards/tags'),
        ]);

        const matchingTag = (tagResponse.data || []).find(
          (item) => String(item.tag_name || '').toLowerCase() === TARGET_PSA_VAULT_TAG.toLowerCase()
        );

        let nextPsaVaultCards = [];

        if (matchingTag) {
          const tagCardsResponse = await Axios.get(`https://api.alientrader.cards/tags/${matchingTag.tag_id}/cards`);
          nextPsaVaultCards = (tagCardsResponse.data?.cards || []).filter(
            (card) => String(card.card_owner || '').toLowerCase() === TARGET_OWNER.toLowerCase()
          );
        }

        if (mounted) {
          setCardList(ownerResponse.data || []);
          setPsaVaultCards(nextPsaVaultCards);
        }
      } catch (error) {
        console.error('Error fetching Matt L cards:', error);
        if (mounted) {
          setCardList([]);
          setPsaVaultCards([]);
          setErrorMessage('Unable to load Matt L cards right now.');
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadCards();

    return () => {
      mounted = false;
    };
  }, []);

  const gradeCount10 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 10).length;
  const gradeCount95 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 9.5).length;
  const gradeCount9 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 9).length;
  const gradeCount85 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 8.5).length;
  const gradeCount8 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 8).length;
  const gradeCount75 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 7.5).length;
  const gradeCount7 = cardList.filter((card) => toGradeNumber(card.card_grade_number) === 7).length;
  const gradeCountBelow7 = cardList.filter((card) => {
    const gradeNumber = toGradeNumber(card.card_grade_number);
    return gradeNumber !== null && gradeNumber < 7;
  }).length;

  return (
    <div className="imagesPage">
      <div
        className="subTopBG"
        style={{
          backgroundImage: `url(${BannerImage})`,
          backgroundPosition: 'center -40px',
        }}
      >
        <div className="actions" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="subBack"></div>
          <div className="sub" style={{ color: '#f4f7fb' }}></div>
          <div className="subEdit" style={{ width: 'auto', marginRight: '0' }}></div>
        </div>
        <div className="subHeader">Matt L</div>
      </div>

      <div className="subPositionAdjust" style={{ top: '-130px' }}>
        <Container fluid style={{ paddingLeft: '30px', paddingRight: '30px' }}>
          <Row className="d-flex align-items-center justify-content-center" style={{ marginBottom: '10px' }}>
            <Col xs="9" sm="5" lg="3" xl="2" className="custom-info-box shadow-sm">
              <Row><div className="custom-info-header">Grades</div></Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">GEM MINT - 10:</div></Col>
                <Col xs={2} sm={2}><div className="custom-info-val">{loading || errorMessage ? '-' : gradeCount10}</div></Col>
                <Col xs={4} sm={4}><div className="custom-info-val"></div></Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">MT - 9:</div></Col>
                <Col xs={2} sm={2}><div className="custom-info-val">{loading || errorMessage ? '-' : gradeCount9}</div></Col>
                {(!loading && !errorMessage && gradeCount95 > 0) ? (
                  <>
                    <Col xs={1} sm={1}><div className="custom-info-title">9.5+</div></Col>
                    <Col xs={3} sm={3}><div className="custom-info-val">{gradeCount95}</div></Col>
                  </>
                ) : (
                  <>
                    <Col xs={1} sm={1}></Col>
                    <Col xs={3} sm={3}></Col>
                  </>
                )}
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">NM-MT - 8:</div></Col>
                <Col xs={2} sm={2}><div className="custom-info-val">{loading || errorMessage ? '-' : gradeCount8}</div></Col>
                {(!loading && !errorMessage && gradeCount85 > 0) ? (
                  <>
                    <Col xs={1} sm={1}><div className="custom-info-title">8.5+</div></Col>
                    <Col xs={3} sm={3}><div className="custom-info-val">{gradeCount85}</div></Col>
                  </>
                ) : (
                  <>
                    <Col xs={1} sm={1}></Col>
                    <Col xs={3} sm={3}></Col>
                  </>
                )}
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">NM - 7:</div></Col>
                <Col xs={2} sm={2}><div className="custom-info-val">{loading || errorMessage ? '-' : gradeCount7}</div></Col>
                {(!loading && !errorMessage && gradeCount75 > 0) ? (
                  <>
                    <Col xs={1} sm={1}><div className="custom-info-title">7.5+</div></Col>
                    <Col xs={3} sm={3}><div className="custom-info-val">{gradeCount75}</div></Col>
                  </>
                ) : (
                  <>
                    <Col xs={1} sm={1}></Col>
                    <Col xs={3} sm={3}></Col>
                  </>
                )}
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Below 7:</div></Col>
                <Col xs={2} sm={2}><div className="custom-info-val">{loading || errorMessage ? '-' : gradeCountBelow7}</div></Col>
                <Col xs={4} sm={4}><div className="custom-info-val"></div></Col>
              </Row>
              <Row><br /></Row>
            </Col>
          </Row>

          <Row className="d-flex align-items-center justify-content-center" style={{ marginBottom: '10px' }}>
            <Col xs="9" sm="5" lg="5" xl="3" className="custom-info-box shadow-sm">
              <Row><div className="custom-info-header">Information</div></Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">Total Cards:</div></Col>
                <Col xs={5} sm={5}><div className="custom-info-val">{loading || errorMessage ? '-' : cardList.length}</div></Col>
              </Row>
              <Row className="d-flex align-items-center justify-content-center">
                <Col><div className="custom-info-title">PSA Vault - Matt L:</div></Col>
                <Col xs={5} sm={5}><div className="custom-info-val">{loading || errorMessage ? '-' : psaVaultCards.length}</div></Col>
              </Row>
              <Row><br /></Row>
            </Col>
          </Row>

          <Row className="d-flex align-items-center justify-content-center">
            <Col xxl={10} xl={11} lg={12} md={12} className="custom-info-box shadow-sm">
              <Row>
                <Tabs id="matt-l-card-wall" activeKey={key} onSelect={(nextKey) => setKey(nextKey || 'cardWall')} className="mb-3">
                  <Tab eventKey="cardWall" title="Card Wall">
                    <Row className="subCardWall d-flex align-items-center justify-content-center">
                      {loading ? (
                        <Col>
                          <div className="custom-info-misc" style={{ justifyContent: 'center', textAlign: 'center' }}>
                            Loading Matt L cards...
                          </div>
                        </Col>
                      ) : errorMessage ? (
                        <Col>
                          <div className="custom-info-misc" style={{ justifyContent: 'center', textAlign: 'center' }}>
                            {errorMessage}
                          </div>
                        </Col>
                      ) : cardList.length > 0 ? (
                        cardList.map((item, index) => (
                          <Col className="imagesPageRow d-flex align-items-center justify-content-center" key={item.card_id}>
                            <CoverDisplay key={index} image={item} />
                          </Col>
                        ))
                      ) : (
                        <Col>
                          <div className="custom-info-misc" style={{ justifyContent: 'center', textAlign: 'center' }}>
                            No cards were found for {TARGET_OWNER}.
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Tab>
                  <Tab eventKey="psaVaultWall" title="PSA Vault">
                    <Row className="subCardWall d-flex align-items-center justify-content-center">
                      {loading ? (
                        <Col>
                          <div className="custom-info-misc" style={{ justifyContent: 'center', textAlign: 'center' }}>
                            Loading PSA Vault cards...
                          </div>
                        </Col>
                      ) : errorMessage ? (
                        <Col>
                          <div className="custom-info-misc" style={{ justifyContent: 'center', textAlign: 'center' }}>
                            {errorMessage}
                          </div>
                        </Col>
                      ) : psaVaultCards.length > 0 ? (
                        psaVaultCards.map((item, index) => (
                          <Col className="imagesPageRow d-flex align-items-center justify-content-center" key={`${item.card_id}-psa-vault`}>
                            <CoverDisplay key={index} image={item} />
                          </Col>
                        ))
                      ) : (
                        <Col>
                          <div className="custom-info-misc" style={{ justifyContent: 'center', textAlign: 'center' }}>
                            No cards were found for the {TARGET_PSA_VAULT_TAG} tag.
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Tab>
                </Tabs>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default MattLPage;
